import posNotificationInstance from '../instance'

const getWatchPairingStatus = (code) => {
	return posNotificationInstance.get(`watchPairingCodes/${code}`)
}

export default getWatchPairingStatus
